import React, { Component } from "react";
import Cardlist from "../Components/Cardlist";
import SearchBox from '../Components/searchBox'
import Scroll from'../Components/Scroll'
import "./App.css"

// STATE >> PROPS

class App extends Component {
    constructor(){
        super()
        this.state =  { robots:[] , searchfield: '' }
    }

    componentDidMount(){
        fetch('https://jsonplaceholder.typicode.com/users') 
        .then(Response=> Response.json())    
        .then(users=> this.setState({robots:users}));
    }

    onsearch = (event) => {
        this.setState({searchfield: event.target.value})
        
        
    }


    render(){
        const {robots , searchfield} =this.state;

        const filterrobot = robots.filter(robot =>{
            return robot.name.toLowerCase().includes(searchfield.toLowerCase())
        })
        return !robots.length ?
             
            <h1 className="tc">Loading</h1>:
         (
            <div className="tc">
            <h1 className="f1">RoboFriends</h1>
            <SearchBox searchchange={this.onsearch} />
        <Scroll>
            <Cardlist robots={filterrobot} />
        </Scroll>

    </div>
        )
    }
}

export default App;